import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import "./style.scss";

export default observer(function ProgressBar({
  calculatePercentProgress,
  countCard,
  completedCards,
}) {
  ProgressBar.propTypes = {
    calculatePercentProgress: PropTypes.func,
    countCard: PropTypes.number,
    completedCards: PropTypes.array,
  };
  return (
    <div className="in-game-page-edit__main__progress-bar-wrapper">
      <div className="in-game-page-edit__main__progress-bar-wrapper__progress-bar">
        <div
          className="in-game-page-edit__main__progress-bar-wrapper__progress-bar__filler"
          style={{
            width: `${calculatePercentProgress()}%`,
          }}
        />
      </div>
      <div className="in-game-page-edit__main__progress-bar-wrapper__count-cards">
        {countCard + 1} / {completedCards?.length}
      </div>
    </div>
  );
});
